import React, { useState } from "react";
import { Button, IconButton } from "@mui/material";
import { Settings } from "@mui/icons-material";

import { MatchmakingLoader } from "./MatchmakingLoader";
import { LocalGameSetup } from "./LocalGameSetup";
import { useApp } from "../contexts/app";
import { cancelStartGame } from "../server/game";

export const GameStart = () => {
  const { state, dispatch, startOnlineGame } = useApp();

  const [failed, setFailed] = useState(false);
  const [localSetupModalIsOpen, setLocalSetupModalIsOpen] = useState(false);
  const [localMatchmakingLoaderIsOpen, setLocalMatchmakingLoaderIsOpen] =
    useState(false);

  const [p1, setP1] = useState("");
  const [p2, setP2] = useState("");

  return (
    <div className="fullheight justify-content-center">
      <div className="d-flex flex-row" style={{ height: "25%" }}>
        <div className="h-100 w-50 pr-3 d-flex">
          <Button
            className="h-100 flex-grow-1"
            // style={{ paddingTop: "20%", paddingBottom: "20%" }}
            // variant="outlined"
            variant="contained"
            size="large"
            onClick={() =>
              dispatch({
                type: "INITIALIZE_GAME",
                payload: {
                  players: ["White", "Black"],
                  onlineGameId: null,
                  localPlayerId: null,
                },
              })
            }
          >
            1v1 Local
            <IconButton
              color="secondary"
              style={{ userSelect: "none" }}
              className="ml-2"
              onClick={(e) => {
                e.stopPropagation();
                setLocalSetupModalIsOpen(true);
              }}
            >
              <Settings style={{ userSelect: "none" }} />
            </IconButton>
          </Button>
        </div>
        <div className="h-100 w-50 pl-3 d-flex">
          <Button
            className="flex-grow-1"
            // style={{ paddingTop: "20%", paddingBottom: "20%" }}
            // variant="outlined"
            variant="contained"
            size="large"
            onClick={() => {
              setLocalMatchmakingLoaderIsOpen(true);
              startOnlineGame().then((success) => {
                // console.log("game start tentative result:", success);
                if (!success) {
                  setFailed(true);
                }
              });
            }}
          >
            ONLINE AUTO-MATCH
          </Button>
        </div>
      </div>
      <LocalGameSetup
        isOpen={localSetupModalIsOpen}
        close={() => {
          setFailed(false);
          setLocalSetupModalIsOpen(false);
        }}
        settings={{
          players: [
            { name: p1, setName: setP1 },
            { name: p2, setName: setP2 },
          ],
        }}
      />
      <MatchmakingLoader
        isOpen={localMatchmakingLoaderIsOpen}
        close={() => {
          setFailed(false);
          cancelStartGame(state.userUuid || "");
          setLocalMatchmakingLoaderIsOpen(false);
        }}
        failed={failed}
      />
    </div>
  );
};
